export enum PrecheckinRoutePaths {
  Default = '',
  Form = 'form',
  Summary = 'summary',
  LandingPage = 'landing-page',
  RateExperience = 'rate-experience'
}
